import * as React from "react";
import { HeadingSmall, LabelMedium } from "kanopi-components/typography";

type TSectionHeader = {
  title: string;
  isTopElement?: boolean;
};

export const SectionHeader = (props: TSectionHeader) => {
  const { title, isTopElement = false } = props;
  const paddingTop = isTopElement ? [0, 0, "scale400"] : 0;

  return (
    <LabelMedium paddingTop={paddingTop} center>
      {title}
    </LabelMedium>
  );
};
